export default defineNuxtRouteMiddleware(async (to, from) => {
  // Skip middleware for certain routes
  const skipRoutes = [
    '/login',
    '/forget-password', 
    '/reset-password',
    '/choice-space'
  ];

  // Skip if not authenticated
  const { isAuthenticated } = useSanctumAuth();
  if (!isAuthenticated.value) {
    return;
  }

  // Skip for guest routes or auth routes
  if (skipRoutes.some(route => to.path.includes(route))) {
    return;
  }

  // Skip if we're already on profile page (to avoid infinite redirect)
  if (to.path.includes('/profile')) {
    return;
  }

  // Skip for API routes
  if (to.path.startsWith('/api/')) {
    return;
  }

  // Skip for root tenant routes (dashboard page should allow access)
  if (to.path === '/' || to.path.match(/^\/[^/]+\/?$/)) {
    return;
  }

  // Only run on client side to avoid hydration issues
  if (import.meta.server) {
    return;
  }

  // Check if security questions are mandatory for this user
  try {
    const apiFetch = useSanctumClient();
    const response = await apiFetch('/api/user/security-questions/status');
    
    // If security questions are mandatory and user doesn't have them
    if (response.mandatory && !response.has_questions) {
      // Store the intended destination
      const intendedPath = to.fullPath;
      
      // Set a flag to show the security questions setup modal
      const securityQuestionsStore = useSecurityQuestionsStore();
      securityQuestionsStore.setRequiredSetup(true, intendedPath);
      
      // Don't redirect, just set the flag - the modal will show on the current page
      return;
    }
    
  } catch (error) {
    // If there's an error checking status, don't block navigation
    console.warn('Could not check security questions status:', error);
  }
});